import { WorkOrderData } from '../../../../api/workOrders/types';
import {
  KPI_HINTS,
  KPI_LABELS,
  PeriodKey,
  PREVIOUS_PERIOD_LABEL,
} from '../../constants';
import {
  deltaPct,
  rejectionPct,
  slaOnTimePct,
  tmcDays,
} from '../../utils/aggregations';
import { KpiCard } from '../KpiCard';
import { Row } from './styles';

interface KpiBarProps {
  current: WorkOrderData[];
  previous: WorkOrderData[];
  loading: boolean;
  period: PeriodKey;
}

export function KpiBar({
  current,
  previous,
  loading,
  period,
}: KpiBarProps): JSX.Element {
  const previousLabel = PREVIOUS_PERIOD_LABEL[period];

  const volumeCurrent = current.length;
  const volumePrev = previous.length;
  const volumeDelta = deltaPct(volumeCurrent, volumePrev);

  const slaCurrent = slaOnTimePct(current);
  const slaPrev = slaOnTimePct(previous);
  const slaDelta = deltaPct(slaCurrent, slaPrev);

  const tmcCurrent = tmcDays(current);
  const tmcPrev = tmcDays(previous);
  const tmcDelta = deltaPct(tmcCurrent, tmcPrev);

  const rejectionCurrent = rejectionPct(current);
  const rejectionPrev = rejectionPct(previous);
  const rejectionDelta = deltaPct(rejectionCurrent, rejectionPrev);

  return (
    <Row>
      <KpiCard
        label={KPI_LABELS.volume}
        value={String(volumeCurrent)}
        hint={KPI_HINTS.volume}
        delta={volumeDelta}
        direction="higher-is-good"
        previousLabel={previousLabel}
        loading={loading}
      />
      <KpiCard
        label={KPI_LABELS.slaOnTime}
        value={`${slaCurrent}%`}
        hint={KPI_HINTS.slaOnTime}
        delta={slaDelta}
        direction="higher-is-good"
        previousLabel={previousLabel}
        loading={loading}
      />
      <KpiCard
        label={KPI_LABELS.tmc}
        value={tmcCurrent > 0 ? `${tmcCurrent}` : '—'}
        hint={KPI_HINTS.tmc}
        delta={tmcDelta}
        direction="lower-is-good"
        previousLabel={previousLabel}
        loading={loading}
      />
      <KpiCard
        label={KPI_LABELS.rejection}
        value={`${rejectionCurrent}%`}
        hint={KPI_HINTS.rejection}
        delta={rejectionDelta}
        direction="lower-is-good"
        previousLabel={previousLabel}
        loading={loading}
      />
    </Row>
  );
}
